import LegalLayout from './LegalLayout';

export default function Terms() {
  return (
    <LegalLayout title="Términos y Condiciones" updatedAt="febrero 2026">
      <p>
        Estos Términos y Condiciones (en adelante, &ldquo;Términos&rdquo;) regulan el acceso y uso de la
        plataforma SaaS <b>Priviax</b> operada por <b>Auttobots SpA</b>, RUT <b>77.674.834-K</b>, con
        domicilio en Cerro el Plomo 5931 Of. 1213, Las Condes, Santiago de Chile. Al crear una cuenta,
        contratar un plan o ingresar al Servicio, usted acepta estos Términos íntegramente.
      </p>

      <h2>1. Objeto</h2>
      <p>
        Priviax es una plataforma web multi-tenant que asiste a organizaciones chilenas en el
        cumplimiento operativo de la <b>Ley N.º 21.719 de Protección de Datos Personales</b>. Incluye
        módulos de RAT, documentos legales, gestión de solicitudes ARCO+, notificación de brechas
        72h, evaluaciones de impacto (DPIA), consentimiento de cookies, trazabilidad y carpeta de
        fiscalización.
      </p>

      <h2>2. Naturaleza del Servicio · No es asesoría legal</h2>
      <p>
        Priviax es una <b>herramienta operativa</b>. Los documentos generados, checklists, plantillas
        y recomendaciones que produce son <b>orientaciones generales</b> basadas en la Ley 21.719 y
        buenas prácticas del mercado, pero <b>no constituyen asesoría legal formal</b>. Para
        decisiones críticas usted debe consultar a un abogado o al DPO de su organización.
      </p>

      <h2>3. Cuenta y responsabilidad del usuario</h2>
      <ul>
        <li>La información que ingresa debe ser exacta y estar actualizada.</li>
        <li>Es responsable de mantener la confidencialidad de su contraseña.</li>
        <li>Es responsable de todas las acciones realizadas desde su cuenta.</li>
        <li>Debe notificarnos de inmediato cualquier acceso no autorizado.</li>
        <li>No puede usar el Servicio para actividades ilegales, spam ni infringir derechos de terceros.</li>
      </ul>

      <h2>4. Planes, precios y facturación</h2>
      <p>Priviax se comercializa en 4 planes:</p>
      <ul>
        <li><b>Starter</b> — $29.900 CLP + IVA / mes · 1–19 personas.</li>
        <li><b>PyME</b> — $79.900 CLP + IVA / mes · 20–99 personas.</li>
        <li><b>Business</b> — $199.900 CLP + IVA / mes · 100–500 personas.</li>
        <li><b>Enterprise</b> — a cotización · 500+ personas o multi-organización.</li>
      </ul>
      <p>
        La facturación es <b>mensual anticipada</b> por defecto, con opción anual (15% de descuento).
        Emitimos boleta o factura electrónica desde SII a nombre de la razón social registrada.
        Los precios pueden actualizarse con <b>60 días de aviso previo</b>; los cambios no afectan
        contratos anuales en curso hasta su renovación.
      </p>

      <h2>5. Prueba gratuita y cambios de plan</h2>
      <p>
        El diagnóstico inicial y el score son gratuitos sin límite de tiempo. Los módulos avanzados
        se activan al contratar un plan. Puede subir o bajar de plan en cualquier momento; el
        prorrateo se calcula automáticamente. Al bajar de plan, algunos módulos quedan bloqueados
        pero <b>los datos históricos se conservan íntegros</b> (visibles al re-subir de plan).
      </p>

      <h2>6. Cancelación y terminación</h2>
      <ul>
        <li>Usted puede cancelar en cualquier momento desde <b>Configuración → Plan</b>. La cancelación surte efecto al final del ciclo pagado — no reembolsamos períodos parciales.</li>
        <li>Auttobots SpA puede suspender o terminar la cuenta en caso de: mora superior a 30 días, uso indebido del Servicio, infracción a estos Términos, o requerimiento de autoridad competente.</li>
        <li>Al terminar la relación entregamos, <b>a solicitud del cliente</b>, una exportación completa de sus datos en formato estructurado (ZIP con RAT, documentos, brechas, DPIA, trazabilidad — incluye hash SHA-256). Ese ZIP se conserva por 90 días adicionales; luego se eliminan definitivamente.</li>
      </ul>

      <h2>7. Propiedad intelectual</h2>
      <p>
        La plataforma, su código, diseño, marca y contenido general son propiedad exclusiva de
        Auttobots SpA. Usted recibe una <b>licencia de uso</b>, no transferible, limitada a la
        vigencia del plan contratado. Los <b>datos que usted ingresa</b> (RAT, documentos, brechas)
        son suyos: los guardamos en depósito y le entregamos copia al terminar la relación.
      </p>

      <h2>8. Confidencialidad</h2>
      <p>
        Auttobots SpA se compromete a mantener en <b>estricta confidencialidad</b> los datos e
        información comercial de sus clientes. El personal de Priviax firma acuerdos de
        confidencialidad. El acceso a datos de un cliente por parte del equipo Priviax solo ocurre
        cuando: (i) el cliente lo autoriza expresamente para soporte; (ii) una autoridad
        competente lo requiere; o (iii) es necesario para prevenir un daño inminente.
      </p>

      <h2>9. Nivel de servicio (SLA)</h2>
      <ul>
        <li><b>Disponibilidad objetivo:</b> 99.5% mensual (Starter/PyME) · 99.9% (Business/Enterprise).</li>
        <li><b>Tiempo de respuesta soporte:</b> 48h hábiles (Starter), 24h (PyME), 8h (Business), 4h (Enterprise).</li>
        <li>Se excluyen ventanas de mantenimiento programado (avisadas con 48h) y eventos de fuerza mayor.</li>
      </ul>

      <h2>10. Limitación de responsabilidad</h2>
      <p>
        Priviax se entrega <i>&ldquo;tal cual&rdquo;</i>. En la máxima medida permitida por la ley chilena:
      </p>
      <ul>
        <li>Auttobots SpA no será responsable por daños indirectos, lucro cesante o daño moral derivados del uso o imposibilidad de uso del Servicio.</li>
        <li>La responsabilidad total agregada de Auttobots SpA frente al cliente está limitada al <b>monto pagado por el cliente durante los 12 meses previos</b> al hecho que originó el reclamo.</li>
        <li>Estas limitaciones no aplican a dolo, culpa grave o cuando la ley chilena las prohíba expresamente.</li>
      </ul>

      <h2>11. Modificaciones</h2>
      <p>
        Podemos actualizar estos Términos cuando cambie la ley, evolucione el Servicio o se agreguen
        funcionalidades. Los cambios se publican en esta misma URL con nueva fecha de actualización.
        Los cambios sustanciales le serán notificados con <b>30 días de anticipación</b> por correo;
        si no está de acuerdo puede terminar el contrato sin penalidad.
      </p>

      <h2>12. Fuerza mayor</h2>
      <p>
        Ninguna parte será responsable por incumplimientos derivados de caso fortuito o fuerza mayor
        (desastres naturales, cortes prolongados de energía o red, actos de autoridad, guerra,
        pandemia, ataques cibernéticos masivos). En tal caso los plazos quedarán suspendidos por el
        tiempo que dure el impedimento.
      </p>

      <h2>13. Ley aplicable y jurisdicción</h2>
      <p>
        Estos Términos se rigen por las leyes de la República de Chile. Cualquier controversia se
        someterá a los <b>tribunales ordinarios de justicia con asiento en la ciudad de Santiago</b>,
        renunciando las partes a cualquier otro fuero. Ambas partes deben intentar de buena fe una
        solución amistosa antes de acudir a tribunales.
      </p>

      <h2>14. Contacto</h2>
      <p>
        <b>Auttobots SpA</b> · RUT 77.674.834-K · Cerro el Plomo 5931 Of. 1213, Las Condes, Santiago, Chile ·{' '}
        <a href="mailto:hola@priviax.cl">hola@priviax.cl</a>.
      </p>
    </LegalLayout>
  );
}
